import { configureStore } from '@reduxjs/toolkit'
import stepSlice from './slice/steps.slice'
import appSlice from './slice/app.slice'
import ivyLeagueSlice from './slice/ivyLeague.slice'
import libertyLakeSlice from './slice/libertyLake.slice'

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    steps: stepSlice.reducer,
    ivyLeague: ivyLeagueSlice.reducer,
    libertyLake: libertyLakeSlice.reducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
